export const calculateGas = (gasAmount: bigint, multiplier: bigint) => {
  const calculated = gasAmount * multiplier;
  return calculated;
};
